"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Bluetooth: ['bluetooth', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.712,8.215a2.174,2.174,0,0,0,.062-3.156L14.253.577A1.68,1.68,0,0,0,12.4.115a1.681,1.681,0,0,0-.972,1.64V8.521a.25.25,0,0,1-.419.184L6.7,4.739A1.25,1.25,0,1,0,5.005,6.578L10.7,11.81a.249.249,0,0,1,0,.368L4.982,17.421a1.25,1.25,0,1,0,1.69,1.842l4.34-3.982a.25.25,0,0,1,.419.184v6.78a1.682,1.682,0,0,0,.973,1.641,1.468,1.468,0,0,0,.57.114,1.835,1.835,0,0,0,1.28-.579l4.52-4.479a2.177,2.177,0,0,0-.059-3.156L14.793,12.18a.251.251,0,0,1,0-.369Zm-2.127,9.008a.253.253,0,0,1,.08.18.245.245,0,0,1-.074.182L14.357,19.8a.25.25,0,0,1-.426-.178V15.354a.25.25,0,0,1,.419-.184Zm-2.235-8.4a.251.251,0,0,1-.419-.184V4.377a.25.25,0,0,1,.426-.177L16.59,6.413a.25.25,0,0,1-.007.362Z']],
  BluetoothTransfer1: ['bluetooth-transfer-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.8,12.182a.249.249,0,0,1,0-.373l4.212-3.771a1.907,1.907,0,0,0,.055-2.81L13.43.746a1.415,1.415,0,0,0-1.591-.4,1.445,1.445,0,0,0-.814,1.406V9.137a.25.25,0,0,1-.417.186L5.692,4.914A1,1,0,1,0,4.357,6.4l6.026,5.405a.25.25,0,0,1,0,.372L4.333,17.6a1,1,0,0,0,1.334,1.49l4.941-4.424a.25.25,0,0,1,.417.187v7.4a1.445,1.445,0,0,0,.815,1.407,1.276,1.276,0,0,0,.494.1,1.56,1.56,0,0,0,1.1-.5l4.631-4.479a1.909,1.909,0,0,0-.053-2.811Zm-.771-8.454a.25.25,0,0,1,.424-.18l2.968,2.871a.25.25,0,0,1-.007.366L13.442,9.442a.25.25,0,0,1-.417-.187Zm.424,16.724a.25.25,0,0,1-.424-.18V14.738a.25.25,0,0,1,.417-.186l2.969,2.663a.247.247,0,0,1,.083.181.25.25,0,0,1-.076.184Z', 'M1.500 12.018 A2.000 2.000 0 1 0 5.500 12.018 A2.000 2.000 0 1 0 1.500 12.018 Z', 'M18.500 12.018 A2.000 2.000 0 1 0 22.500 12.018 A2.000 2.000 0 1 0 18.500 12.018 Z']],
  BluetoothTransfer: ['bluetooth-transfer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    transform: 'translate(-2.502 17.958) rotate(-45.001)'
  }, {
    transform: 'translate(-7.438 6.042) rotate(-45.001)'
  }], ['M13.992,12.179a.25.25,0,0,1-.08-.184.248.248,0,0,1,.081-.184l4.6-4.221a1.518,1.518,0,0,0,.484-1.08,1.5,1.5,0,0,0-.444-1.089L13.807.635A1.5,1.5,0,0,0,11.25,1.7V9.088a.251.251,0,0,1-.419.185l-4.9-4.51A1,1,0,0,0,4.573,6.236l6.063,5.574a.25.25,0,0,1,.08.184.248.248,0,0,1-.081.184L4.548,17.762A1,1,0,1,0,5.9,19.237l4.932-4.525a.25.25,0,0,1,.419.185v7.4a1.5,1.5,0,0,0,2.556,1.065l4.828-4.786a1.5,1.5,0,0,0-.04-2.17ZM13.25,3.5a.25.25,0,0,1,.426-.178l2.991,2.965a.245.245,0,0,1,.074.182.248.248,0,0,1-.081.18L13.669,9.394a.25.25,0,0,1-.419-.185Zm.426,17.177a.25.25,0,0,1-.426-.177V14.782a.25.25,0,0,1,.419-.184l2.993,2.752a.249.249,0,0,1,.08.179.244.244,0,0,1-.074.182Z', 'M18.592 10.166 L22.259 10.166 L22.259 13.833 L18.592 13.833 Z', 'M1.741 10.166 L5.408 10.166 L5.408 13.833 L1.741 13.833 Z']],
  BluetoothOn: ['bluetooth-on', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.99,12.179a.249.249,0,0,1,0-.368l4.6-4.221a1.5,1.5,0,0,0,.04-2.169L9.806.638A1.5,1.5,0,0,0,7.248,1.7v7.39a.25.25,0,0,1-.419.184l-4.9-4.509A1,1,0,0,0,.571,6.236L6.633,11.81a.249.249,0,0,1,0,.368L.546,17.763A1,1,0,1,0,1.9,19.237l4.932-4.524a.25.25,0,0,1,.419.184v7.4A1.5,1.5,0,0,0,9.8,23.365l4.824-4.783a1.5,1.5,0,0,0-.037-2.173ZM9.248,3.5a.25.25,0,0,1,.426-.177l2.991,2.965a.25.25,0,0,1,.074.183.246.246,0,0,1-.081.179L9.667,9.394a.25.25,0,0,1-.419-.184Zm.426,17.177a.25.25,0,0,1-.426-.177V14.783a.25.25,0,0,1,.419-.184l2.992,2.751a.249.249,0,0,1,.08.179.246.246,0,0,1-.074.183Z', 'M21.293,6.107a1,1,0,1,0-1.414,1.415,6.5,6.5,0,0,1,0,9.192,1,1,0,1,0,1.414,1.414A8.51,8.51,0,0,0,21.293,6.107Z', 'M16.549,8.937a1,1,0,0,0,0,1.415,2.5,2.5,0,0,1,0,3.534A1,1,0,1,0,17.964,15.3a4.5,4.5,0,0,0,0-6.364A1,1,0,0,0,16.549,8.937Z']]
};
exports["default"] = _default;